import { DialogMessenger } from './dialogMessenger';
import { Environment } from './environment';

//!!!Do not change as long as old addin is around!!!
export const LocalStorageDialogMessengerName = 'LocalStorageDialogMessenger';
export class LocalStorageDialogMessenger extends DialogMessenger {
    private asyncCallbacks: {
        [key: string]: (result: Office.AsyncResult<any>) => void;
    } = {};

    private runningPullTimer = null;
    private proxyCounter = 0;
    private argsKey: string;

    constructor(private needsLegacyTimer: boolean) {
        super();
        //Build up necessary API's
        if (!needsLegacyTimer) {
            window.addEventListener("storage", (ev: StorageEvent) => {
                if (this.asyncCallbacks[ev.key]) {
                    this.handleCallback(ev.key, ev.newValue);
                }
            });
        }
    }

    private handleCallback(key: string, newValue: string) {
        //Deserialize & execute callback method
        let data = JSON.parse(newValue).args;
        if (this.asyncCallbacks[key] && typeof (this.asyncCallbacks[key]) === 'function')
            this.asyncCallbacks[key].apply(this, data);
        //Clear callback & storage of result
        delete this.asyncCallbacks[key];
        localStorage.removeItem(key);
    }

    private resetLocalStorage() {
        /*
            DO NOT REMOVE
            Outlook 2013 does not sync localStorage automatically. With a setItem it is in sync again and getItem returns the correct values.
        */
        window.localStorage.setItem('yasoon', new Date().getTime().toString());
    }

    private timeoutFunc() {
        //For Outlook 2013
        if (Office.context.mailbox.diagnostics) {
            let platform = Environment.getPlatform();
            if (platform === 'PC' && Office.context.mailbox.diagnostics.hostVersion.indexOf('15') === 0) {
                this.resetLocalStorage();
            }
        }
        if (Object.keys(this.asyncCallbacks).length === 0) {
            clearInterval(this.runningPullTimer);
            this.runningPullTimer = null;
            return;
        }
        let keys = Object.keys(this.asyncCallbacks);
        keys.forEach(key => {
            let value = localStorage.getItem(key);
            if (value) {
                this.handleCallback(key, value);
            }
        });
    }

    async setData(key: string, message: string) {
        localStorage.setItem(key, message);
    }

    async getData(key: string): Promise<string> {
        return localStorage.getItem(key);
    }

    callAsyncMethod(message: any, callback: (data: any) => void) {
        if (this.needsLegacyTimer && !this.runningPullTimer) {
            this.runningPullTimer = setInterval(() => this.timeoutFunc(), 50);
        }
        let cbkId = null;
        if (callback && typeof (callback) === 'function') {
            cbkId = "dialog-cbk-" + new Date().getTime().toString() + "-" + this.proxyCounter++;
            this.asyncCallbacks[cbkId] = callback;
        }
        message.callbackId = cbkId;
        message.type = 'callAsync';
        Office.context.ui.messageParent(JSON.stringify(message));
    }

    cleanup() {
        Object.keys(localStorage).forEach(key => {
            if (key.indexOf('dialog-cbk-') === 0 || key.indexOf('dialog-args-') === 0)
                localStorage.removeItem(key);
        });
    }

    getName() {
        return LocalStorageDialogMessengerName;
    }
}
